var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClientOrders = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#client-orders_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M120 60c0 33.137-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0s60 26.863 60 60Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D1E0D9",
  d: "M98.29 81.953c-4.682 8.069-12.559 7.909-15.912 6.82.46-2.968 11.286-17.105 16.641-23.802 5.017 6.855 1.604 14.178-.73 16.982Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6CEC2",
  d: "M82.932 71.743c4.689-8.081 12.578-7.921 15.936-6.83-.46 2.972-11.304 17.132-16.668 23.84-5.025-6.866-1.606-14.2.732-17.01Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.661,
  d: "M83.04 71.377c4.364-6.76 12.685-7.446 16.3-6.945 4.084 8.836.75 15.889-.988 18.245-6.37 6.942-13.107 6.961-15.68 6.103-5.006-7.022-1.841-14.528.367-17.403ZM82.903 87.537l10.722-14.816"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#36485C",
  strokeWidth: 0.557,
  d: "M33.197 35.55v-4.924h20.338v4.923h-3.278l3.873 7.855v7.882H32.06v-9.527l4.042-3.823V35.55h-2.905Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M31.97 51.587v-8.405c0-1.82 1.473-4.527 3.295-4.527a1.132 1.132 0 0 0 1.132-1.142v-1.578h14.35v1.578a1.135 1.135 0 0 0 1.14 1.142"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M31.97 51.587v-8.405c0-1.82 1.473-4.527 3.295-4.527a1.132 1.132 0 0 0 1.132-1.142v-1.578h14.35v1.578a1.135 1.135 0 0 0 1.14 1.142"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M35.713 35.934c0-.378.306-.685.685-.685h14.35c.379 0 .685.307.685.685v1.583a.45.45 0 0 0 .452.452.685.685 0 1 1 .006 1.371 1.818 1.818 0 0 1-1.828-1.83v-.89h-12.98v.89a1.822 1.822 0 0 1-1.815 1.83h-.002c-.565 0-1.209.438-1.759 1.273-.535.813-.851 1.816-.851 2.569v8.405a.685.685 0 0 1-1.37 0v-8.405c0-1.066.42-2.327 1.077-3.323.641-.974 1.645-1.89 2.902-1.89a.448.448 0 0 0 .448-.452v-1.583Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCF3DD",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M52.936 30.52H34.212c-.637 0-1.152.515-1.152 1.152v3.11c0 .637.515 1.153 1.152 1.153h18.724c.636 0 1.152-.516 1.152-1.153v-3.11c0-.637-.516-1.152-1.152-1.152Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M34.21 31.205a.467.467 0 0 0-.467.467v3.11c0 .258.209.467.467.467h18.724c.258 0 .467-.21.467-.467v-3.11a.467.467 0 0 0-.468-.467H34.21Zm-1.838.467c0-1.015.823-1.838 1.838-1.838h18.724c1.014 0 1.837.823 1.837 1.838v3.11a1.838 1.838 0 0 1-1.837 1.838H34.21a1.838 1.838 0 0 1-1.838-1.838v-3.11Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M49.667 51.166c0-1.822 1.476-4.53 3.296-4.53a1.135 1.135 0 0 0 1.131-1.132V43.93h10.78v1.588c.004.298.125.581.336.79.211.21 1.53.593 1.53.593l-3.975 4.266"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M49.667 51.166c0-1.822 1.476-4.53 3.296-4.53a1.135 1.135 0 0 0 1.131-1.132V43.93h10.78v1.588c.004.298.125.581.336.79.211.21 1.53.593 1.53.593l-3.975 4.266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M53.41 43.928c0-.378.307-.685.685-.685h10.78c.379 0 .686.307.686.685v1.583c.002.104.04.203.106.281.03.016.077.039.14.066.132.056.299.117.47.176a16.207 16.207 0 0 0 .642.204l.01.003h.003a.685.685 0 0 1 .31 1.126l-3.975 4.266a.685.685 0 0 1-1.003-.934l3.246-3.484a6.379 6.379 0 0 1-.24-.096 3.108 3.108 0 0 1-.26-.123 1.243 1.243 0 0 1-.281-.202 1.82 1.82 0 0 1-.54-1.268v-.912h-9.408v.892a1.82 1.82 0 0 1-1.816 1.815h-.002c-.563 0-1.207.438-1.758 1.274-.536.813-.852 1.816-.852 2.57a.685.685 0 0 1-1.37 0c0-1.067.421-2.328 1.078-3.325.642-.973 1.645-1.889 2.901-1.89a.45.45 0 0 0 .448-.447v-1.575Zm12.232 1.85a.073.073 0 0 0 0 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCF3DD",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M66.541 38.5H52.422c-.636 0-1.152.516-1.152 1.152v3.11c0 .637.515 1.153 1.152 1.153h14.119c.636 0 1.153-.516 1.153-1.152v-3.11c0-.637-.517-1.153-1.153-1.153Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M52.422 39.185a.467.467 0 0 0-.467.467v3.11c0 .258.209.468.467.468H66.54c.258 0 .467-.21.467-.467v-3.11a.467.467 0 0 0-.467-.468H52.42Zm-1.838.467c0-1.015.823-1.837 1.838-1.837H66.54c1.015 0 1.838.822 1.838 1.837v3.11A1.838 1.838 0 0 1 66.54 44.6H52.42a1.838 1.838 0 0 1-1.837-1.837v-3.11ZM24.521 51.527c0-.378.307-.685.686-.685h37.421c.379 0 .686.307.686.685v38.244a.685.685 0 0 1-.686.685H28.497a3.975 3.975 0 0 1-3.976-3.975V51.527Zm1.371.685v34.27a2.605 2.605 0 0 0 2.605 2.604h33.446V52.213h-36.05Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M61.942 51.527c0-.378.307-.685.686-.685h18.779c.379 0 .685.307.685.685v34.954a3.975 3.975 0 0 1-3.975 3.975h-15.49a.685.685 0 0 1-.685-.685V51.527Zm1.371.685v36.874h14.804a2.605 2.605 0 0 0 2.605-2.605V52.213H63.313Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.279,
  d: "M75.693 39.185a.411.411 0 0 0-.292.121l-11.55 11.602h16.822l10.973-11.021a.411.411 0 0 0-.291-.702H75.693Zm-1.263-.846a1.782 1.782 0 0 1 1.263-.524h15.662c1.585 0 2.381 1.915 1.263 3.039L81.444 52.077a.685.685 0 0 1-.486.202H62.201a.685.685 0 0 1-.486-1.169L74.43 38.34ZM13.356 40.854c-1.119-1.124-.323-3.04 1.262-3.04H30.28c.475 0 .93.19 1.264.526l1.696 1.707a.685.685 0 0 1-.972.966l-1.696-1.706a.41.41 0 0 0-.292-.122H14.618a.411.411 0 0 0-.29.702L25.5 51.11a.685.685 0 0 1-.971.967L13.356 40.854Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#client-orders_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  d: "M49.215 68.97v.051c0 .203-.31 4.468-5.67 6.397v-2.665L46.78 69.3a.757.757 0 0 0-.052-1.091.794.794 0 0 0-1.113.05l-2.071 2.234V68.183c.258-.583 1.501-2.868 4.556-2.868h.078c1.217 1.422 1.036 3.63 1.036 3.655Zm-7.224 1.523-2.097-2.233a.786.786 0 0 0-1.088-.051.78.78 0 0 0-.051 1.091l3.236 3.453v2.64c-5.36-1.93-5.644-6.22-5.67-6.397v-.051c0-.025-.207-2.234 1.01-3.655h.103c3.081 0 4.298 2.31 4.557 2.868v2.335Zm7.12-6.498a.882.882 0 0 0-.492-.228c-2.925-.178-4.841 1.294-5.851 2.665-1.01-1.37-2.9-2.843-5.852-2.665-.181 0-.362.101-.492.228-1.89 1.853-1.683 4.798-1.657 5.077 0 .203.13 1.65 1.088 3.325.906 1.6 2.822 3.706 6.628 4.772.026 0 .052 0 .052.026h.414c.026 0 .052 0 .078-.026 7.068-1.954 7.69-7.539 7.715-8.072.026-.152.285-3.198-1.63-5.102Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#D1E0D9",
  d: "M87.42 72.532c2.98 8.839-2.331 14.656-5.36 16.46-1.93-2.302-5.424-19.762-6.93-28.204 8.462.746 11.719 8.14 12.29 11.744Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6CEC2",
  d: "M69.618 77.351c-2.987-8.853 2.334-14.68 5.367-16.487 1.932 2.306 5.433 19.794 6.941 28.25-8.475-.748-11.737-8.153-12.308-11.763Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.661,
  d: "M69.413 77.029c-2.206-7.738 2.762-14.448 5.523-16.835 9.336 2.753 12.442 9.908 13.068 12.768 1.021 9.367-3.405 14.446-5.746 15.814-8.58-.863-12.139-8.191-12.845-11.747ZM81.476 87.782 77.4 69.953"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "client-orders_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v120H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "client-orders_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M34.612 63.64h16.312v13.707H34.612z"
})))));
export default SvgClientOrders;